module.exports = __webpack_public_path__ + "img/united-kingdom.a0f21f7b.png";